import { Candidate, Page, PageRequest } from '$synapse/models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { genericBaseUrl } from './utils';
import { CandidateSummary } from '$synapse/dtos';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private readonly _http = inject(HttpClient);

  _baseUrl(...path: any[]): string {
    return genericBaseUrl(`${environment.settings.api.url}`, ...path);
  }

  findCandidatesWithAssessmentsStats(
    page: PageRequest
  ): Observable<Page<CandidateSummary>> {
    return this._http
      .get<Page<any>>(this._baseUrl('manager/dashboard/candidates'), {
        params: page.params(),
      })
      .pipe(
        map((response) => {
          const content = response.content;
          page = page.setDefaultSort('lastname,desc');
          return new Page(page, content, response.totalPages);
        })
      );
  }

  findCandidatesWithGroupId(
    page: PageRequest
  ): Observable<Page<CandidateSummary>> {
    return this._http
      .get<Page<any>>(
        this._baseUrl(`manager/groups/${page.groupId}/candidates`),
        {
          params: page.params(),
        }
      )
      .pipe(
        map((response) => {
          const content = response.content;
          page = page.setDefaultSort('lastname,asc');
          return new Page(page, content, response.totalPages);
        })
      );
  }
}
